import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import LeadsPage from "@/pages/LeadsPage";
import { api } from "@/lib/api";

export const STAGE_PILL = {
  slate: "bg-slate-100 text-slate-700",
  blue: "bg-blue-100 text-blue-700",
  sky: "bg-sky-100 text-sky-700",
  indigo: "bg-indigo-100 text-indigo-700",
  violet: "bg-violet-100 text-violet-700",
  amber: "bg-amber-100 text-amber-700",
  emerald: "bg-emerald-100 text-emerald-700",
  rose: "bg-rose-100 text-rose-700",
  teal: "bg-teal-100 text-teal-700",
  orange: "bg-orange-100 text-orange-700",
};

function buildConfig(p) {
  const stages = (p.stages || []).slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const labels = stages.map((s) => s.label);
  const statusPill = {};
  stages.forEach((s) => {
    statusPill[s.label] = STAGE_PILL[s.color] || STAGE_PILL.slate;
  });
  return {
    pipeline: p.id,
    title: p.name,
    statusField: "status",
    defaultStatus: labels[0] || "New",
    stages: labels,
    chipStages: labels,
    showRefByMe: false,
    referToCounseling: false,
    statusPill,
  };
}

export default function CustomPipelinePage() {
  const { pipelineId } = useParams();
  const [pipeline, setPipeline] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    (async () => {
      try {
        const r = await api.get("/admin/pipelines");
        const p = (r.data?.pipelines || []).find((x) => x.id === pipelineId);
        if (alive) setPipeline(p || null);
      } catch {
        if (alive) setPipeline(null);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [pipelineId]);

  if (loading) {
    return (
      <div className="flex h-[60vh] items-center justify-center text-slate-400">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" /> Loading…
      </div>
    );
  }
  if (!pipeline) {
    return (
      <div className="flex h-[60vh] items-center justify-center text-sm text-slate-500">
        Section not found.
      </div>
    );
  }

  return <LeadsPage key={pipeline.id} config={buildConfig(pipeline)} />;
}
